<template>
 
  <div id="ServiceCodeContradictory" class="row " >

     <b-modal id="ServiceCodePrereqServiceCodesAddEdit"  size="lg" v-model="showEditModal"  no-close-on-esc no-close-on-backdrop hide-header-close
          ok-variant cancel-variant hide-footer
          header-class="PopUpHeader" 
          :body-bg-variant=PopUpVar.bodyBgVariant
          :body-text-variant=PopUpVar.bodyTextVariant
          :footer-bg-variant=PopUpVar.footerBgVariant
          :footer-text-variant=PopUpVar.footerTextVariant> 
        <ServiceCodeContradictoryAddEdit  v-if="showEditModal==true" :Codes="ServiceCodes" :UserData="UserData" :UserRow="editedRow" :DataSet="tableData" :CurrentCode="serviceCode" :CurrentCodeDesc="CurrentCodeDesc" :mode="mode" @ContradictoryUpdate="UpdateRecord"></ServiceCodeContradictoryAddEdit>
        
        <template slot="modal-header"> 
            <div>
            <small class="modal-title PopUpTitle w-100 text-left ">{{mode}} Contradictory Service Codes</small>
          </div> 
          <div v-show="mode=='Edit'"><small class="modal-title w-100 text-right"></small></div>
        </template> 
        <div slot="modal-footer" class="w-100"> 
        </div>
      </b-modal>

    <div class="col-5 ">
      <label for="VueTables_Adduser" class="VueTables_user small p-0 m-0">Contradictory Service Code:</label>
      <div slot="beforeBody"  class="VueTables_Adduser small">
        <button :disabled="readonly  || this.ServiceCodes.length<=0 || maxRows || !this.serviceCode.length" v-on:click="AddPrereqServiceCodesPopup()" type="button"  class="btn btn-primary btn-smlb">Add Contradictory Service Code</button>
      </div>
    </div>
    <div class="col-7">
      <v-client-table class="small" :columns="columns" :data="tableData" :options="options">
        <span class="pointer" v-on:click="DeleteRecordMsgBox('Are you sure you want to delete this contradictory Service Codes?'   ,props)" slot="delete" slot-scope="props" ><i class="far fa-trash-alt"></i></span>
        <span class="pointer" v-on:click="EditPrereqServiceCodesPopup(props)" slot="edit" slot-scope="props" ><i class="far fa-edit"></i></span>
      </v-client-table> 
    </div>
  </div>
</template>

<script>
import { PopUpVariant } from '@/Common/Default/PopUpVariant';
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Modal from '../../../Common/ModelPop.vue';
import ServiceCodeContradictoryAddEdit from '@/components/DPEBB/Administrator/ServiceCodeContradictoryAddEdit.vue';
const MaxContradictoryCodes = 40

export default {
props:{
      Data:'',
      ReadOnly:false,
      Codes:'',
      CurrentCode:'',
      CurrentCodeDesc:''
    },
     data: function(){
        return {
            PopUpVar:PopUpVariant,
            showModal:false,
            isValid:false,
            Access:'',
            AllowAdd:false,
            showEditModal:false,
            isValid:'',
            Button:'',
            readonly:false,
            mode:'',
            ServiceCodes:[],
            maxRows:false,
        columns: ['delete','edit','codeServiceContradictory','codeDescDental','codeUnitContradictory','numUnitConradictory'],
        tableData: [],
        options: {
          skin:"table-striped table-bordered table-hover",
          pagination: { edge: true },
        texts:{
              count:"",
              first:'First',
              last:'Last',
              filter:"",
              limit:"Records:",
              page:"Page:",
              noResults:"No matching records",
              filterBy:"Filter by {column}",
              loading:'Loading...',
              defaultOption:'Select {column}',
              columns:'Columns'
          }, 
       
          responseAdapter({data}) {
           
              return {
                data: formatData,
                count: data.length
              };
             
            },
         
          perPage:5,
          perPageValues:[10,15,25],
          toMomentFormat: 'YYYY-MM-DD',
        

          headings: {
            delete:'',
            edit:'',
            codeServiceContradictory: 'Service Code',
            codeDescDental: 'Extra Info',
            codeUnitContradictory: 'Duration Unit',
            numUnitConradictory: 'Duration Length'
          },
          pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 5
          },
                   templates: {
                   codeUnitContradictory(h, row){
              switch(row.codeUnitContradictory.toUpperCase()){
                case 'D':
                  return 'Days'
                case 'M':
                  return 'Months'
                case 'Y':
                  return 'Years'
                case 'L':
                  return 'Lifetime'
                default:
                  return '';
              }
            }
          },
         // sortable: [],
         sortable: ['codeServiceContradictory','codeDescDental','codeUnitContradictory','numUnitConradictory'],
         filterable: '', 
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
            },
       
        }
        
        },
        components: {
          Modal:Modal,
          Card,
          CardBody,
          TileNote,
          ServiceCodeContradictoryAddEdit
        },
        
        created:function(){
            //console.log("Contra Pre Req service code "+ this.CurrentCode)
            this.tableData = this.Data;
            this.readonly = this.ReadOnly;
            this.ServiceCodes = this.Codes;
            console.log('at contra created')
           // console.log('selected service type ='+this.ServiceCodes[0].type)
            //this.tableData = this.Data;
            this.maxRows = this.tableData.length == MaxContradictoryCodes;
            this.serviceCode = this.CurrentCode;
            console.log('current SC at create' + this.serviceCode)
        },
        mounted() {
            // hide admin column
            if (this.readonly) {
                  this.columns.splice(this.columns.findIndex(column => column == 'edit'), 1);
        }
    },
    methods:{
    setValue(value) {
        //console.log(' at child' + value)
        this.serviceCode = value;
    },
      UpdateRecord(value){
        this.showEditModal = false;
        //console.log(value.codeUnitContradictory);
        if(this.editedRow != -1){
          this.tableData[this.editedRow].codeDescDental = value.codeDescDental;
          this.tableData[this.editedRow].codeServiceContradictory = value.codeServiceContradictory;
          this.tableData[this.editedRow].codeUnitContradictory = value.codeUnitContradictory;
          this.tableData[this.editedRow].numUnitConradictory = value.numUnitConradictory;
        }
        else{
            this.tableData.push({codeDescDental:value.codeDescDental,
             codeServiceContradictory:value.codeServiceContradictory,
             codeUnitContradictory:value.codeUnitContradictory,
             numUnitConradictory:value.numUnitConradictory});
        }
        this.maxRows = this.tableData.length == MaxContradictoryCodes;
      },
      EditPrereqServiceCodesPopup(Rowdata){
          this.editedRow = Rowdata.index -1;
          this.mode='Edit';
          this.UserData = Rowdata.row
          this.showEditModal=true;
      },
      AddPrereqServiceCodesPopup(){
          this.mode='Add';
          this.editedRow = -1;
          this.UserData = '';
          this.showEditModal=true;
      },
       DeleteRecordMsgBox(msg,data){
        this.boxTwo = ''
        this.$bvModal.msgBoxConfirm(msg, {
          title: 'Please Confirm',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          cancelVariant: 'default',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: true,
          centered: true, 
        })
        .then(value => {
          this.boxTwo = value
          var vm = this;
          if(value)
          {
            this.tableData.splice((data.index -1),1);
            this.maxRows = this.tableData.length == MaxContradictoryCodes;
          }
        })
        .catch(err => {
          console.log(err);
        })
    }
  }
}
</script>

<style>
#ServiceCodeContradictory  .modal-dialog {
    max-width: 70%;
    margin: 0;
    top: 5%;
    bottom: 0;
    left: 20%;
    right: 20%;
    height: 45vh;
    display: flex;
    /* position: fixed; */
    z-index: 100000;
}
</style>
